export default class AppSearch {
	constructor() {
		this.searchForm = document.getElementById('search-form');
	}

	init() {
		if (this.searchForm) {
			this.searchForm.addEventListener('submit', e => {
				e.preventDefault();
				return false;
			});
		}
	}
}
